import { createReducer, current } from '@reduxjs/toolkit'
import { getByTopic, getByTopicFirstCall, setTopic } from './actions'

const initialState = {
  nature: {
    topicPhotos: [],
    totalTopicPhotos: 0,
    scrollToImgId: null,
  },
  interiors: {
    topicPhotos: [],
    totalTopicPhotos: 0,
    scrollToImgId: null,
  },
  art: {
    topicPhotos: [],
    totalTopicPhotos: 0,
    scrollToImgId: null,
  },
  travel: {
    topicPhotos: [],
    totalTopicPhotos: 0,
    scrollToImgId: null,
  },
  topic: 'nature'
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getByTopicFirstCall.fulfilled, (state, action) => {
      const topic = action.meta?.arg?.query || 'not-a-topic'

      if (state[topic]?.topicPhotos?.length === 0) { // Prevent duplicate set
        state[topic].topicPhotos = state[topic].topicPhotos.concat(action.payload.media)
        state[topic].totalTopicPhotos = action.payload.total_results
      }
    })
    .addCase(getByTopic.fulfilled, (state, action) => {
      const topic = action.meta?.arg?.query || 'not-a-topic'
      const page = action.meta.arg.page
      if (state[topic]?.topicPhotos?.length === (page - 1) * 12) { // only concat results if it's not the right page
        state[topic].topicPhotos = state[topic].topicPhotos.concat(action.payload.media)
        state[topic].totalTopicPhotos = action.payload.total_results
      }
    })
    .addCase(setTopic, (state, action) => { // Also saves current (now prev) topic's last viewed image
      const currentTopic = current(state).topic
      const nextTopic = action.payload

      // Find all img elements on the page
      const imgElements = document.querySelectorAll('img')

      // Initialize variables to store the upper left-most image and coordinates
      let upperLeftMostImage = null
      let minTop = Infinity
      let minLeft = Infinity

      // Iterate through each img element to find upper left-most
      imgElements.forEach((img) => {
        const imgRect = img.getBoundingClientRect()
        const imgTop = imgRect.top
        const imgLeft = imgRect.left
        const imgCenterY = imgTop + imgRect.height / 2 // Center point

        // Check if the image is a search result and is the upper left-most with center point > 80px from the top
        const isSearchResultImg = img.classList.contains('SearchResult__image')
        const isInSight = imgCenterY > 80
        const isMoreUpperLeft = imgTop < minTop || (imgTop === minTop && imgLeft < minLeft)

        if (isSearchResultImg && isInSight && isMoreUpperLeft) {
          minTop = imgTop
          minLeft = imgLeft
          upperLeftMostImage = img
        }
      })

      // Check if an image was found and store its id attribute for this topic
      if (upperLeftMostImage?.id) {
        const idAttribute = upperLeftMostImage.id
        state[currentTopic].scrollToImgId = idAttribute
      }

      state.topic = nextTopic
    })
    .addDefaultCase((state, action) => {})
})

export function selectTopicPhotos(state) {
  const currentTopic = state.home.topic
  return state.home[currentTopic].topicPhotos
}

export function selectTotalTopicPhotos(state) {
  const currentTopic = state.home.topic
  return state.home[currentTopic].totalTopicPhotos
}

export function selectTotalScrollToImgId(state) {
  const currentTopic = state.home.topic
  return state.home[currentTopic].scrollToImgId
}

export function getTopic(state) {
  return state.home.topic
}
